// Custom hook for accessing toast notifications
// CREATED: Simple hook to access showToast function from anywhere in the app
// Usage: const { showToast } = useToast(); showToast('Message', 'success');

import { useContext } from 'react';
import { ToastContext } from '../contexts/ToastContext';

export function useToast() {
  const context = useContext(ToastContext);

  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }

  return context;
}
